import React, {useState} from 'react';
import CheckIcon from '@material-ui/icons/Check';
import cn from 'classnames';
import Loading from 'components/pure/utils/Loading';
import Tooltip from '@material-ui/core/Tooltip';

interface ActiveCellProps {
  onChange: () => Promise<void> | undefined;
  active: boolean;
  allowToggle: boolean;
}

export const ActiveCell: React.FC<ActiveCellProps> = props => {
  const [loading, setLoading] = useState(false);
  if (loading) {
    return <Loading />;
  }

  // If we're allowed to toggle the active state, wrap the checkbox in a tooltip
  // and set up a click handler.
  if (props.allowToggle) {
    const enableOrDisable = props.active ? 'disable' : 'enable';
    const title = `Click to ${enableOrDisable} login`;
    return (
      <Tooltip title={title}>
        <CheckIcon
          className={cn(props.active ? 'active' : 'inactive', 'admin-users-cell')}
          onClick={
            props.allowToggle &&
            (async () => {
              try {
                setLoading(true);
                await props.onChange();
              } finally {
                setLoading(false);
              }
            })
          }
        />
      </Tooltip>
    );
  }

  // If we're not allowed to toggle, just return a disabled checkbox.
  return (
    <CheckIcon
      className={cn(props.active ? 'active' : 'inactive', 'admin-users-cell', 'disabled')}
    />
  );
};
